export function getSourceControlProviderLabel(
  provider: string
): "GitLab" | "BitBucket" | "GitHub" | string {
  let label = "";
  switch (provider) {
    case "GITLAB":
      label = "GitLab";
      break;
    case "GITHUB":
      label = "GitHub";
      break;
    case "BITBUCKET":
      label = "BitBucket";
      break;
    default:
      label = provider;
      break;
  }

  return label;
}
